import './navigation.scss';
import {I18NParagraph} from "../../Elements";
import { UntitledColorizeIcon } from '../../Basic/icons';
import type { NavigationEntryProps } from "./Navigation.interface.ts";

/**
 * Primary UI component for user interaction
 */
export function NavigationEntry(props: NavigationEntryProps) {

  return (
      <button aria-label={props.id} id={props.id} onClick={props.onClick} className={"navigation-entry"}>
        {props.icon ? <UntitledColorizeIcon name={props.icon} />: <></>}
        {
          props.i18nNote ?
              <div className={"navigation-entry-note"}>
                <I18NParagraph i18n={props.i18nLabel} className={"strong"}/>
                <I18NParagraph i18n={props.i18nNote}/>
              </div>
              :
              <I18NParagraph i18n={props.i18nLabel} className={"strong"}/>
        }
        {
          props.children
        }
      </button>
  );
}
